import React from 'react';

export default function EventNoteActionButton({
  messageNoteId,
  onOpen,
  className = 'system-message-card__link',
  style = undefined,
}) {
  return (
    <button
      type="button"
      className={className}
      onClick={onOpen}
      title="ノートを表示"
      aria-label="ノートを表示"
      style={style}
    >
      {messageNoteId ? 'ノートを開く' : 'ノートを見る'}
    </button>
  );
}
